// extracted by mini-css-extract-plugin
export default {"gridExt":"styles_gridExt__mZj3Z","section":"styles_section__8XUat","leftContent":"styles_leftContent__kM6kh"};